<template>
  <!-- 弹窗 -->
  <div>
    <!--  -->
    <div class="pop-img" v-if="isModel" >
      <div ref="maskContent">
        <div class="cover-div mask-bg" ref="popMask">
         <span> {{currency}}书币</span>
          <span class="btn" @click="getCurrency">立即领取</span>
        </div>
        <div class="close-img">
          <img src="../../../static/close-x.png" @click="closeJump" alt="" />
        </div>
      </div>
    </div>
    <div class="pop-img" v-if="!isModel&&isActivity&&tabbarIndex==1">
      <div ref="maskContent">
        <div class="cover-div" ref="popMask">
          <img
            class="cover-img"
            ref="popImg"
            @click="jumpBook"
            @load="handleLoad"
            :src="imgUrl"
            alt=""
          />
        </div>
        <div class="close-img">
          <img src="../../../static/close-x.png" @click="closeJump" alt="" />
        </div>
      </div>
    </div>
 
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";
import buyBook from "./buyBook.vue";
export default {
  name: "pop-activity",
  components: {
    buyBook,
  },
  props:['pagetype','type','chapterId','bookIds','tabbarIndex'],
  data() {
    return {
      isActivity: false,//书城弹窗
      isModel:false,//领取月卡书币
      loadTimes: 0, //一天加载书城弹窗次数
      lastLoadTime: "", //最后加载时间
      currentIndex: 0,
      activityId: "",
      bookId: "",
      url: "",
      imgUrl: "",
      pageUrl: "",
      couponIds: "",
      spashId: "",
      pageParams: "",
      clickBehavior: "",
      clickBehaviorFlag: "",
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      userCurrency: 0, //用户剩余书币
      purchaseWholeBook: 0,
      chapterIds: "",
      chapterOrder: "",
      currency:0,//用户领取书币
      queryType:0
    };
  },
  mounted() {
    console.log('2222')
    if(this.tabbarIndex!=-1&&this.pagetype == 0||this.tabbarIndex==5){
      this.monthCards();
    }
    
window.addEventListener("resize", ()=>{
    if (window.orientation === 180 || window.orientation === 0) {
        // 正常方向或屏幕旋转180度
        console.log('竖屏');
        this.handleLoad();
    };
 
    if (window.orientation === 90 || window.orientation === -90 ){
      this.handleLoad();
        // 屏幕顺时钟旋转90度或屏幕逆时针旋转90度
        console.log('横屏');
    }
});
    
  },
  methods: {
    monthCards() {
      //弹窗
      var params = {
        queryType: this.queryType,
      };
      this.$api
        .monthCards(params)
        .then((res) => {
          if (res.status == 1) {
            if(this.queryType==0){//获取书币
              this.currency=res.data;
                  if(res.data){
                  this.isModel = true;
                }else{
                  this.isModel = false;
                  console.log(this.pagetype)
                  if (this.pagetype == 0) {
                    this.getPopup();
                  }
                }
            }else{
              Toast({
                message: '领取成功',
              });
              if(this.tabbarIndex==3){
                this.$emit("eventTab", { data: 3 });
              }
              this.getUserCurrency();
              this.isModel = false;
            }
          } else {
            this.isModel = false;
          }
        })
        .catch((res) => {
          console.log(res);
          // 失败进行的操作
        });
    },
    getUserCurrency() {
      var params = {
        random: Math.random(),
      };
      this.$api.getUserCurrency(params).then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("currency", res.data);
        }
      });
    },
    getCurrency(){
      this.queryType=1;
      this.monthCards();

    },
    handleLoad() {
      // if(!this.imgUrl){
      //   return false;
      // }
      this.$nextTick(() => {
        var offsetHeight = 0,
          clientHeight = 0;
            offsetHeight = this.$refs.popImg.offsetHeight;
        clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
          console.log('.......'+offsetHeight);
        console.log(clientHeight);
        if (offsetHeight + 100 >= clientHeight) {
          this.$refs.popMask.style.height = clientHeight - 100 + "PX";
          this.$refs.popMask.style.overflow = "hidden";
        }else{
          this.$refs.popMask.style.height = 'auto';
          this.$refs.popMask.style.overflow = "hidden";
        }
        
      });
    },
    buyChange(data) {
      if (data) {
        if (data == 1) {
          this.purchaseWholeBook = 1;
          // this.isActivity = false;
          this.commonRead(this.isEntranceData);
          // this.$router.push({
          //   path: "/pages/bookRead/index",
          //   query: {
          //     bookid: this.bookId,
          //     pageType: "bookCity",
          //     isEntranceData: this.isEntranceData,
          //   },
          // });
        } else if (data == 2) {
          this.showBuyMask = false;
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.bookId,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
    getPopup() {
      this.loadTimes = this.$base.getStorage("loadTimes");
      //弹窗
      var params = {
        todayTimes: this.loadTimes,
        isRechargePage: this.pagetype,
      };
      this.$api
        .getPopup(params)
        .then((res) => {
          if (res.status == 1) {
            console.log(res.data);
            if (
              res.data.imgUrl &&
              (res.data.bookId ||
                res.data.url ||
                res.data.activityId ||
                res.data.couponIds ||
                res.data.pageUri)
            ) {
              this.bookId = res.data.bookId;
              this.chapterIds = res.data.chapterId;
              this.chapterOrder = res.data.chapterOrder;
              this.url = res.data.url;
              this.imgUrl = res.data.imgUrl;
              this.jumpChoice = res.data.jumpChoice;
              this.activityId = res.data.activityId;
              this.couponIds = res.data.couponIds;
              this.pageUrl = res.data.pageUri;
              this.pageParams = res.data.pageParams;
              this.clickBehavior = res.data.clickBehavior;
              this.clickBehaviorFlag = res.data.clickBehaviorFlag;
              this.isActivity = true;
              this.spashId = res.data.id;
              this.loadTimes++;
              var that = this;
              that.lastLoadTime = that.$base.getDateTime();
              this.$base.setStorage("lastLoadTime", that.lastLoadTime);
              this.$base.setStorage("loadTimes", that.loadTimes);
            } else {
              this.isActivity = false;
            }
          } else {
            this.isActivity = false;
          }
        })
        .catch((res) => {
          console.log(res);
          // 失败进行的操作
        });
    },

    commonRead(isEntranceData) {
      //判断书籍是否能进入阅读器
      this.isEntranceData = isEntranceData;
      var params = {
        bookId: this.bookId,
        chapterId: this.chapterIds,
        chapterorder: this.chapterOrder,
        order: 0,
        booktype: "",
        isauto: 0,
        rechargeOrderNum: "", //订单编号
        purchaseWholeBook: this.purchaseWholeBook,
        currentPageType: 1,
      };
      this.$api.findChapterContentByChapterId(params).then((res) => {
        if (res.status == 1) {
          this.showBuyMask = false;
          this.purchaseWholeBook = 0;
          this.$router.push({
            path: "/pages/bookRead/index",
            query: {
              bookid: this.bookId,
              pageType: "bookCity",
              isEntranceData: isEntranceData,
            },
          });
          this.isActivity = false;
        } else if (res.status == 3) {
          this.showBuyMask = true;
          this.countCurrency = res.data.wholeBookCurrency;
          this.userCurrency = res.data.accountCurrency;
        } else if (res.status == 100 || res.status == 200||res.status==4) {
          if (res.data) {
            if(res.status==100&&res.data.priceType==3){
              this.$router.push({
                path: "/pages/bookCharge/index",
                query: {
                  bookId: this.bookId,
                  chapterId: res.data.id,
                  needCurrency: res.data.chapterPrice,
                  pageType: "bookRead",
                  priceType:res.data.priceType
                },
              });
              }else{
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId: this.bookId
                },
              });
              } 
          }
        }
      });
    },
    jumpBook() {
      var pageType = this.pagetype == 0 ? "bookCity" : "bookCharge";
      var name = this.pagetype == 0 ? "书城弹窗" : "充值页弹窗";
      var isEntranceData =
        name +
        "(2:" +
        this.spashId +
        ":" +
        this.clickBehavior +
        ":" +
        this.clickBehaviorFlag +
        ":-1:-1)";
      if (this.clickBehavior === 0) {//阅读器和书籍详情
        if (this.jumpChoice == 1) {
          this.commonRead(isEntranceData);
          return false;
        } else {
          this.$router.push({
            path: "/pages/bookDetail/index",
            query: {
              bookId: this.bookId,
              pageType: pageType,
              isEntranceData: isEntranceData,
            },
          });
        }
      } else if (this.clickBehavior === 2) {//跳转活动
        this.$router.push({
          path: "/pages/bookModelActivity/index",
          query: {
            activityId: this.activityId,
            pageType: pageType,
            isEntranceData: isEntranceData,
            isBookRead: this.type,
            bookId: this.bookIds,
            chapterId: this.chapterId,
          },
        });
      } else if (this.clickBehavior === 1) {//外链
        this.$router.push({
          path: "/pages/bookWeb/index",
          query: {
            url: this.url,
            pageType: pageType,
            isEntranceData: isEntranceData,
            isBookRead: this.type,
          },
        });
      } else if (this.clickBehavior === 3) {////跳转领取优惠券页面
        this.$router.push({
          path: "/pages/getCoupons/index",
          query: {
            couponIds: this.couponIds,
            pageType: pageType,
            isEntranceData: isEntranceData,
            isBookRead: this.type,
          },
        });
      } else  if (this.clickBehavior == 4||this.clickBehavior==5) {
        //跳转到任意页面
        var params = { pageType: pageType, isEntranceData: isEntranceData};
          if(this.pageUrl=='/?tabIndex=0'||this.pageUrl=='/?tabIndex=1'||this.pageUrl=='/?tabIndex=2'||this.pageUrl=='/?tabIndex=3'){
          var type=this.pageUrl.split('=')[1]
         this.$emit("eventTab", { data: type });
        }else{
        this.$router.push({
          path: this.pageUrl,
          query: params,
        });
      }
      }
      this.isActivity = false;
    },
    closeJump() {
      this.isActivity = false;
      this.isModel = false;
    },
  },
};
</script>

<style scoped>
/* 图片弹窗做最大限制   */
.pop-img {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.pop-img > div {
  width: 270px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.mask-bg{
background-image: url('../../../static/month_mask.png');
width: 280px;
height: 320px;
background-size:cover;
}
.mask-bg>span:nth-of-type(1){
  font-size: 20px;
color: #E62A25;
text-align: center;
display: block;
width:130px;
margin-top: 215px;
margin-left:76px;
}
.mask-bg>span:nth-of-type(2){
  width: 130px;
height: 32px;
background-image: linear-gradient(180deg, #FFF873 0%, #FF910B 100%);
border-radius: 15.5px;
text-align: center;
line-height: 32px;
font-size: 14px;
color: #B50500;
display: block;
position: absolute;
left:75px;
bottom: 67px;
}
.cover-div {
  width: 270px;
  overflow: hidden;
  
}
.pop-img .cover-img {
  max-width: 270px;
  display: block;
  margin: 0 auto;
}
.pop-img .close-img {
  width: 40px;
  height: 40px;
  display: block;
  margin: 12px auto;
  text-align: center;
}
.close-img img {
  width: 24px;
  height: 24px;
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/view/components/pop-activity.vue